import BasicContentTile from './BasicContentTile';

export { type BasicContentTileProps } from './BasicContentTile';
export default BasicContentTile;
